<template>
  <Select size="large" :options="options" placeholder="请选择" @change="onChange" :loading="loading"></Select>
</template>
<script setup lang="ts">
import { getDict } from '@/api/common'
import { Select } from 'ant-design-vue'
import { onMounted, ref } from 'vue'

const props = defineProps<{
  dictName: string
}>()

const options = ref()
const emit = defineEmits(['input'])
function onChange(val: string) {
  emit('input', val)
}

const loading = ref(false)
onMounted(() => {
  loading.value = true
  getDict(props.dictName)
    .then((response) => {
      if (Array.isArray(response.data)) {
        options.value = response.data.map((i) => ({
          label: i.dictLabel,
          value: i.dictValue,
        }))
      }
    })
    .finally(() => {
      loading.value = false
    })
})
</script>
<style lang="less" scoped></style>
